import { createAction } from '@reduxjs/toolkit';

export const requestCreateReaction = createAction('request/createReaction');
export const requestViewReactions = createAction('request/viewReactions');
export const requestDeleteReaction = createAction('request/deleteReaction');
export const requestSwitchReaction = createAction('request/switchReaction');
